// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eW4cA","title":"styles_title__H_rgG","link":"styles_link__upbuY"};